// 1. Dependencies
import { nodeConfig } from '@scripts/mixins';
import { Calendar as VanillaCalendar } from 'vanilla-calendar-pro';
import merge from 'lodash/merge';

// 2. Configuration
export const NAMESPACE = 'calendar';
export const DEFAULT_SELECTOR = '[data-js-calendar]';
export const DEFAULT_SETTINGS = {
};

// 3. Module
export class Calendar {
	/** @param {HTMLElement} node */
	constructor(node, config) {
		this.elNode = node;
		this.elCalendar = this.elNode.querySelector('[data-js-calendar-calendar]');
		this.elCalendarInput = this.elNode.querySelector('[data-js-calendar-input]');

		this.config = config;
		this.api = null;
	}

	get selectedDate() {
		return this.elCalendarInput?.value ?? null;
	}

	onClickDate(self, event) {
		const newDate = event.target.parentElement.getAttribute('data-vc-date');

		this.elCalendarInput.value = newDate;

		this.elNode.dispatchEvent(new CustomEvent('calendar:change', {
			bubbles: true,
			detail: {
				date: newDate,
			}
		}));
	}

	init() {
		const additionalConfig = {
			onClickDate: this.onClickDate.bind(this),
			selectedTheme: 'dark',
		};

		if (this.selectedDate) {
			additionalConfig.selectedDates = [this.selectedDate];
		}

		this.config = merge(this.config, additionalConfig);
		this.api = new VanillaCalendar(this.elCalendar, this.config);
		this.api.init();
	}
}

// 4. Factory Function
export default function factory(selector = DEFAULT_SELECTOR, settings = {}) {
	const listNode = document.querySelectorAll(selector);

	if (!listNode.length) return;

	return Array.from(listNode).map((node) => {
		const config = nodeConfig(node, NAMESPACE, settings, DEFAULT_SETTINGS);
		const module = new Calendar(node, config);

		module.init();

		return module;
	});
}
